// extracted by mini-css-extract-plugin
var _1 = "FloatingTooltipContentText-moduleFloatingTooltipContentText__SS1TQ";
var _2 = "FloatingTooltipContentText-moduleadditionalText__yxASO";
var _3 = "FloatingTooltipContentText-moduletext__OMqYx";
export { _1 as "FloatingTooltipContentText", _2 as "additionalText", _3 as "text" }
